import { useState } from 'react'
import * as LucideIcons from 'lucide-react'
import { ETL_NODE_REGISTRY, ETL_NODE_CATEGORIES } from '../../data/etlNodeRegistry'
import './EtlNodePalette.css'

function EtlNodePalette({ disabled }) {
  const [searchTerm, setSearchTerm] = useState('')
  const [expandedCategories, setExpandedCategories] = useState({
    templates: true,
    sources: true,
    transforms: false,
    targets: false,
    quality: false,
    utility: false,
  })

  const toggleCategory = (catKey) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [catKey]: !prev[catKey],
    }))
  }

  const handleDragStart = (e, nodeType) => {
    if (disabled) {
      e.preventDefault()
      return
    }
    e.dataTransfer.setData('application/etlflow', nodeType)
    e.dataTransfer.effectAllowed = 'move'
  }

  return (
    <div className="etl-palette">
      <div className="etl-palette-header">
        <span>Nodes</span>
      </div>

      <div className="etl-palette-search">
        <LucideIcons.Search size={14} />
        <input
          placeholder="Search nodes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button onClick={() => setSearchTerm('')}>
            <LucideIcons.X size={12} />
          </button>
        )}
      </div>

      <div className="etl-palette-list">
        {Object.entries(ETL_NODE_CATEGORIES).map(([catKey, category]) => {
          const filteredNodes = category.nodes.filter((nodeType) => {
            const def = ETL_NODE_REGISTRY[nodeType]
            if (!def) return false
            if (!searchTerm) return true
            return (
              def.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
              def.description?.toLowerCase().includes(searchTerm.toLowerCase())
            )
          })

          if (filteredNodes.length === 0) return null

          const CategoryIcon =
            LucideIcons[category.icon] || LucideIcons.Box
          const isExpanded = searchTerm
            ? true
            : expandedCategories[catKey]

          return (
            <div key={catKey} className="etl-palette-category">
              <div
                className="etl-palette-category-header"
                onClick={() => toggleCategory(catKey)}
              >
                <span
                  className="etl-palette-category-dot"
                  style={{ backgroundColor: category.color }}
                />
                <span className="etl-palette-category-label">
                  {category.label}
                </span>
                <span className="etl-palette-category-count">
                  {filteredNodes.length}
                </span>
                {isExpanded ? (
                  <LucideIcons.ChevronDown size={14} />
                ) : (
                  <LucideIcons.ChevronRight size={14} />
                )}
              </div>

              {isExpanded && (
                <div className="etl-palette-items">
                  {filteredNodes.map((nodeType) => {
                    const nodeDef = ETL_NODE_REGISTRY[nodeType]
                    const NodeIcon =
                      LucideIcons[nodeDef.icon] || LucideIcons.Box
                    return (
                      <div
                        key={nodeType}
                        className={`etl-palette-item ${disabled ? 'disabled' : ''}`}
                        draggable={!disabled}
                        onDragStart={(e) => handleDragStart(e, nodeType)}
                        title={nodeDef.description}
                      >
                        <NodeIcon
                          size={14}
                          style={{ color: nodeDef.color }}
                        />
                        <span>{nodeDef.label}</span>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default EtlNodePalette
